<template lang="pug">
.bank-list
  v-layout.pa-6(v-if="isFetching")
    v-row.fill-height.ma-0(align='center' justify='center')
      v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
  v-list.pa-0(v-else)
    v-list-item-group(v-model="selectedBankIndex", color="primary")
      template(v-for="(bank, index) in banks")
        v-divider(v-if="index != 0")
        v-list-item(:key="bank.code" v-slot:default="{ active, toggle }")
          v-list-item-icon.my-3
            v-card
              v-img(:src="bank.image ? bank.image : require('@/assets/image_placeholder.png')" width=24, height=24)
          v-list-item-content {{ bank.name }}
          v-list-item-action.my-0(v-show="active")
            v-btn(icon)
              v-icon(color="success") mdi-check
</template>

<script>
export default {
  name: "FPXPicker",
  props: ['value'],
  data: () => ({
    isFetching: true,
    bankImages: [
      { name: '2C2P Payment Gateway', image: require('@/assets/images/fpx/2c2p.png') },
      { name: 'Affin Bank', image: require('@/assets/images/fpx/ABB0233.png') },
      { name: 'Alliance Bank', image: require('@/assets/images/fpx/ABMB0212.png') },
      { name: 'Alliance Bank Malaysia', image: require('@/assets/images/fpx/ABMB0212.png') },
      { name: 'AGRONet', image: require('@/assets/images/fpx/AGRO01.png') },
      { name: 'AmBank', image: require('@/assets/images/fpx/AMBB0209.png') },
      { name: 'CIMB Clicks', image: require('@/assets/images/fpx/BCBB0235.png') },
      { name: 'CIMB', image: require('@/assets/images/fpx/BCBB0235.png') },
      { name: 'Bank Islam', image: require('@/assets/images/fpx/BIMB0340.png') },
      { name: 'Bank Islam Malaysia', image: require('@/assets/images/fpx/BIMB0340.png') },
      { name: 'Bank Rakyat', image: require('@/assets/images/fpx/BKRM0602.png') },
      { name: 'Bank Muamalat', image: require('@/assets/images/fpx/BMMB0341.png') },
      { name: 'Bank Muamalat Malaysia', image: require('@/assets/images/fpx/BMMB0341.png') },
      { name: 'BSN', image: require('@/assets/images/fpx/BSN0601.png') },
      { name: 'Bank Simpanan Nasional', image: require('@/assets/images/fpx/BSN0601.png') },
      { name: 'Hong Leong Bank', image: require('@/assets/images/fpx/HLB0224.png') },
      { name: 'HSBC Bank', image: require('@/assets/images/fpx/HSBC0223.png') },
      { name: 'HSBC', image: require('@/assets/images/fpx/HSBC0223.png') },
      { name: 'KFH', image: require('@/assets/images/fpx/KFH0346.png') },
      { name: 'Kuwait Finance House', image: require('@/assets/images/fpx/KFH0346.png') },
      { name: 'Maybank2E', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'Maybank2U', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'Maybank', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'OCBC Bank', image: require('@/assets/images/fpx/OCBC0229.png') },
      { name: 'Public Bank', image: require('@/assets/images/fpx/PBB0233.png') },
      { name: 'RHB Now', image: require('@/assets/images/fpx/RHB0218.png') },
      { name: 'RHB Bank', image: require('@/assets/images/fpx/RHB0218.png') },
      { name: 'Standard Chartered', image: require('@/assets/images/fpx/SCB0216.png') },
      { name: 'UOB Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      { name: 'United Overseas Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      { name: 'PayPal', image: require('@/assets/images/fpx/Paypal.png') }
    ],
    banks: [],
    selectedBankIndex: null
  }),
  watch: {
    selectedBankIndex (val) {
      this.$emit('input', this.banks[val].code)
    }
  },
  mounted () {
    this.fetchBanks()
  },
  methods: {
    fetchBanks() {
      this.$axios.get(`/banks/?gateway=billplz&active=true&staging=false`)
          .then((resp) => {
            this.isFetching = false
            resp.data.results.forEach(bank => {
              const selectedBank = this.bankImages.filter((obj) => {
                return obj.name.toLowerCase() == bank.name.toLowerCase()
              })
              bank['image'] = ''
              if (selectedBank.length != 0) {
                bank['image'] = selectedBank[0].image
              }
              this.banks.push(bank)
            })
            if (this.value) {
              const index = this.banks.findIndex(b => b.code === this.value)
              if (index > 0) {
                this.selectedBankIndex = index
              }
            }
          }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>